<template>
  <div :class="['content', {wrapped: !!headline[type], left: align=='left', right: align=='right'}]">
    <h2 v-if="headline[type]">{{ headline[type] }}</h2>
    <component :is="componentName" :data="data" />
  </div>
</template>

<script>

  import cmtext from './content-module/text'
  import cmimage from './content-module/image'
  import cmvideo from './content-module/video'
  import cmaudio from './content-module/audio'
  import cmcrunch from './content-module/number-crunch'
  import cmresearch from './content-module/research-links'
  import cmdiscuss from './content-module/discuss'

  export default {
    name: 'ContentModule',
    props: {
      type: {
        type: String,
        required: true
      },
      data: {
        type: Object,
        required: true
      },
      align: {
        type: String
      }
    },
    data () {
      return {
        headline: {
          audio: "Listen",
          crunch: "Number Crunch",
          research: "Research Links",
          discuss: "Discuss"
        }
      }
    },
    components: { cmtext, cmimage, cmvideo, cmaudio, cmcrunch, cmresearch, cmdiscuss },
    computed: {
      componentName () {
        return `cm${this.type}`
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .content {
    @include margin(1rem null 3rem);
    @include noTopOrBottom(margin);
    display:block;
    &.wrapped {
      @include padding(3rem);
      margin-top:1rem; background-color:$color-gray-background; box-shadow:$box-shadow; position:relative; border-radius:3px;
      h2 {
        @include font-size(xsmall, $headline:true);
        display:flex; align-items:center; width:100%; text-align:center; color:$color-black; padding-bottom:3rem;
        &:before, &:after {
          content:''; flex:2; height:1px; background:$color-gray-darker;
        }
        &:before {
          margin-right:2rem;
        }
        &:after {
          margin-left:2rem;
        }
      }
    }
    &.wrapped:first-child + .content {
      margin-top:0;
    }
  }

  .active {
    .content + .wrapped {
      @include padding(3rem);
    }
  }

  .closed {
    @include media(xxlarge) {
      .left,.right {
        width:50%; margin-bottom:1rem;
        & + .content {
          clear:none;
        }
      }
      .left {
        float:left; margin-right:4rem;
      }
      .right {
        float:right; margin-left:4rem;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module.vue